import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useOnMount from '../../hooks/useOnMount';

export default function ScrollReset({
  id,
  className,
  style,
  scrollHash,
  onScroll,
  children,
}) {
  const scrollRef = useRef(null);

  function scrollToTop() {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
      scrollRef.current.scrollLeft = 0;
    }
  }

  useOnMount(scrollToTop);

  useEffect(() => {
    scrollToTop();
  }, [scrollHash]);

  return (
    <div
      data-testid="scrollReset"
      ref={scrollRef}
      id={id}
      className={className}
      style={style}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
}

ScrollReset.propTypes = {
  scrollHash: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onScroll: PropTypes.func,
  children: PropTypes.node.isRequired,
};
